export interface Question {
  name: string;
  text: string;
  datetime: string; // YYYY-MM-DD HH:MI:SS
  answer: string | null;
  answer_datetime: string | null; // YYYY-MM-DD HH:MI:SS
}

export type Questions = Question[]; 